import Vue from 'vue'
import {fetchSystemGuideProgress, saveSystemGuideProgress} from '@/api/modules/system'

const {progressId, shouldAutoStart} = require('./runtimeCore.cjs')

const VALID_STATUSES = new Set(['VIEWED', 'COMPLETED', 'DISMISSED'])
const state = Vue.observable({
  recordsById: {},
  initialized: false,
  unavailable: false,
})

let loadingPromise = null
let generation = 0
const sessionSeen = new Set()

/** 登录后非阻塞加载当前账号进度；失败只关闭自动弹出，不影响任何业务页面。 */
export function initializeGuideProgress() {
  if (state.initialized || loadingPromise) return loadingPromise || Promise.resolve(true)
  const currentGeneration = generation
  loadingPromise = fetchSystemGuideProgress()
      .then((rows) => {
        if (currentGeneration !== generation) return false
        const recordsById = {}
        ;(rows || []).forEach((item) => {
          if (!item || !item.guideKey || !item.guideVersion || !VALID_STATUSES.has(item.guideStatus)) return
          recordsById[progressId(item.guideKey, item.guideVersion)] = item
        })
        state.recordsById = recordsById
        state.initialized = true
        state.unavailable = false
        return true
      })
      .catch(() => {
        if (currentGeneration === generation) {
          state.initialized = false
          state.unavailable = true
        }
        return false
      })
      .finally(() => {
        if (currentGeneration === generation) loadingPromise = null
      })
  return loadingPromise
}

/** 仅当服务端成功加载且没有当前版本记录时，允许本次会话自动展示。 */
export function shouldAutoShowGuide(guide) {
  return shouldAutoStart({
    guide,
    initialized: state.initialized,
    recordsById: state.recordsById,
    sessionSeen,
  })
}

/** 启动前立即登记本次会话，避免快速路由切换造成同一版本重复弹出。 */
export function markGuideSeenInSession(guide) {
  if (guide) sessionSeen.add(progressId(guide))
}

/** 保存进度失败时静默降级；引导和后台业务仍可继续使用。 */
export async function saveGuideStatus(guide, guideStatus) {
  if (!guide || !VALID_STATUSES.has(guideStatus) || state.unavailable) return null
  try {
    const saved = await saveSystemGuideProgress({
      guideKey: guide.key,
      guideVersion: guide.version,
      guideStatus,
    })
    Vue.set(state.recordsById, progressId(saved.guideKey, saved.guideVersion), saved)
    state.initialized = true
    return saved
  } catch (error) {
    return null
  }
}

/** 返回当前版本状态，帮助中心用它判断按钮显示“开始”还是“重新查看”。 */
export function getGuideStatus(guide) {
  if (!guide) return ''
  return state.recordsById[progressId(guide)]?.guideStatus || ''
}

/** 退出登录或登录失效时清空上一个账号状态，避免短暂串号。 */
export function resetGuideProgress() {
  generation += 1
  loadingPromise = null
  sessionSeen.clear()
  state.recordsById = {}
  state.initialized = false
  state.unavailable = false
}
